import dayjs from "dayjs";
import { isNil } from "ramda";
import { AND, GREAT_EQUAL, LESS_EQUAL, PROP } from "../constants/formula";
export const getNewTimeStamp = (val, format, endFormat) => {
  return dayjs(dayjs(val).format(format) + endFormat).valueOf();
};
export const getMonthDays = (time, format) => {
  const [y, m] = dayjs(time).format(format).split("/");
  return new Date(y, m, 0).getDate();
};
export const getDateFormatTimeStamp = (dateFormat, x) => {
  let timeStampArr = [];
  let x0 = x.value[0],
    x1 = x.value[1];
  if (x.value[2] != undefined && ~x.value[2]) {
    x1 = dayjs(dayjs(x.value[1]).format("YYYY/MM/DD") + " 23:59:59").valueOf();
    x0 = x1 - ((x.value[2] + 1) * 24 * 3600 * 1000 - 1000);
  }
  switch (true) {
    case /^YYYY(-|\/)?MM(\1)?DD(\1)?(\s)?HH(:)?mm$/.test(dateFormat):
      timeStampArr = [getNewTimeStamp(x0, "YYYY/MM/DD HH:mm", ":00"), getNewTimeStamp(x1, "YYYY/MM/DD HH:mm", ":59")];
      break;
    case /^YYYY(-|\/)?MM$/.test(dateFormat):
      timeStampArr = [getNewTimeStamp(x0, "YYYY/MM/DD", " 00:00:00"), getNewTimeStamp(x1, "YYYY/MM", `/${getMonthDays(x1, "YYYY/MM")} 23:59:59`)];
      break;
    case /^YYYY$/.test(dateFormat):
      timeStampArr = [getNewTimeStamp(x0, "YYYY", "/01/01 00:00:00"), getNewTimeStamp(x1, "YYYY", "/12/31 23:59:59")];
      break;
    case /^MM$/.test(dateFormat):
      timeStampArr = [getNewTimeStamp(x0, "YYYY/MM", "/01 00:00:00"), getNewTimeStamp(x1, "YYYY/MM", `/${getMonthDays(x1, "YYYY/MM")}  23:59:59`)];
      break;
    case /^(YYYY|DD)(-|\/)?MM(\2)?(DD|YYYY)$/.test(dateFormat):
    case /^MM(-|\/)?DD$/.test(dateFormat):
    case /^DD$/.test(dateFormat):
      timeStampArr = [getNewTimeStamp(x0, "YYYY/MM/DD", " 00:00:00"), getNewTimeStamp(x1, "YYYY/MM/DD", " 23:59:59")];
      break;
  }
  return timeStampArr;
};

//设置排序参数
export const getOrderByParam = viewConfig => {
  let val;
  const param = viewConfig.orderBy;
  /**
   * 视图的排序根据
   * 目前排序比较准确的规则：创建时间  更新时间  主题树排序
   */
  if (/^templateProp_/.test(param)) {
    val = `p${param.split("_")[2]}`;
  } else if (/^_sys_createTime$/.test(param)) {
    val = `createTime`;
  } else if (/^templateStatus$/.test(param)) {
    val = `si`;
  } else if (/^templateStatusPropBase_2$/.test(param)) {
    val = `startTime`;
  } else if (/^templateStatusPropBase_3$/.test(param)) {
    val = `endTime`;
  } else if (/^_sys_updateTime$/.test(param)) {
    val = "modifyTime";
  } else if (/^treeLevel$/.test(param)) {
    val = "treeLevel";
  }
  return val ? viewConfig && viewConfig.orderDesc ? [`-${val}`] : [`+${val}`] : null;
};

//获取相关视图类型
export const handleViewType = type => {
  switch (type) {
    /**
     * templateStatusPropBase 存在第二个数字
     * 就说明是按成员组进行分组
     */
    case "templateStatusPropBase_0":
      return "templateStatusPropBase_0";
    case "templateStatusPropBase_0_0":
      return "templateStatusPropBase_0_0";
    case "templateStatusPropBase_0_1":
      return "templateStatusPropBase_0_1";
    case "templateStatusPropBase_1":
      return "templateStatusPropBase_1";
    case "templateStatusPropBase_1_0":
      return "templateStatusPropBase_1_0";
    case "templateStatusPropBase_1_1":
      return "templateStatusPropBase_1_1";
    case "templateStatus":
      return "status";
    case "sysCreator":
      return "sysCreator";
    case "_sys_tag":
      return "sysTag";
    case "historyStatus":
      return "historyStatus";
    case "templateStatusOwnerAndParticipant":
      return "templateStatusOwnerAndParticipant";
    case "templateStatusOwnerAndParticipant_0":
      return "templateStatusOwnerAndParticipant_0";
    case "templateStatusOwnerAndParticipant_1":
      return "templateStatusOwnerAndParticipant_1";
    default:
      return "temp";
  }
};
export const handleFilterReqParam = (filterReq, searchPropsData, viewInfo, viewConfig, baseUserId, storeUserId, hasHistoryStatus, filterNodeOption, propList) => {
  // 筛选 searchPropsData
  if (searchPropsData?.selectData && Object.keys(searchPropsData?.selectData).length) {
    const filterKeys = Object.keys(searchPropsData.selectData);
    const selectData = searchPropsData.selectData;
    filterKeys.forEach(x => {
      const k = x.split("_");
      if (k[0] === "templateProp") {
        const tempArr = selectData[x].reduce((a, b) => {
          a.push(`p${k[2]}-${b}`);
          return a;
        }, []);
        filterReq.tempProps.push(tempArr);
      } else if (k[0] === "templateStatus") {
        const statusArr = selectData[x].reduce((a, b) => {
          a.push(`si-${b.split("_")[1]}`);
          return a;
        }, []);
        filterReq.tempProps.push(statusArr);
      }
    });
  }

  //分组条件
  filterReq = handleGroupCondition(filterReq, viewInfo);

  //筛选的参数==兼容新版本
  filterReq = handleConditionParam(filterReq, viewConfig, baseUserId, storeUserId, hasHistoryStatus, propList);

  //附加的筛选条件(搜索情况下会使用)
  filterReq = handleFilterNodeOption(filterReq, filterNodeOption);
  const sortBy = getOrderByParam(viewConfig);
  if (sortBy) {
    filterReq.sortBy = sortBy;
    filterReq.arrayGroup = true;
  } else {
    delete filterReq.sortBy;
    delete filterReq.arrayGroup;
  }
  return filterReq;
};
export const generateViewInfo = data => {
  //生成viewInfo
  let viewInfo = {
    type: null,
    group: null
  };
  if (/^templateProp_/.test(data)) {
    // 自定义属性
    viewInfo.type = "temp";
    viewInfo.group = data;
  } else if (/^sysCreator$/.test(data)) {
    //创建人
    viewInfo.type = data;
  } else if (/^_sys_tag$/.test(data)) {
    //标签
    viewInfo.type = "sysTag";
  } else if (/^templateStatusPropBase_0_0$/.test(data) || /^templateStatusPropBase_0_1$/.test(data) || /^templateStatusPropBase_1_0$/.test(data) || /^templateStatusPropBase_1_0$/.test(data) || /^templateStatusPropBase_1_1$/.test(data) || /^templateStatusOwnerAndParticipant_0$/.test(data) || /^templateStatusOwnerAndParticipant_1$/.test(data)) {
    viewInfo.type = data;
  } else if (/^templateStatus$/.test(data)) {
    viewInfo.type = "status";
  } else if (/^dayHours$/.test(data)) {
    viewInfo.type = "";
  }
  return viewInfo;
};
export const generateViewConfig = (data, node) => {
  //生成viewConfig
  let viewConfig = {
    condition: [],
    conditionV2: [],
    group: null,
    orderBy: null,
    orderDesc: false
  };
  if (data?.conditions?.length) {
    viewConfig.conditionV2 = [...data.conditions];
  }
  if (data?.matchings?.length) {
    //追加conditionV2

    const tempProps = node.prop._sys_temp[1];
    data.matchings.forEach(x => {
      const value = tempProps[x.target];
      const inp = Array.isArray(value) ? value : [value];
      viewConfig.conditionV2.push({
        op: "intersect",
        key: "prop",
        input: inp,
        index: x.origin
      });
    });
  }
  if (data.nodePath && viewConfig?.conditionV2[0]["key"] != "ancestor" && viewConfig.conditionV2.length <= 2) {
    viewConfig.conditionV2.unshift({
      op: "intersect",
      key: "ancestor",
      input: [data.nodePath]
    });
  }
  if (data.orderBy) {
    viewConfig.orderBy = data.orderBy;
  }
  if (data.orderDesc) {
    viewConfig.orderDesc = data.orderDesc;
  }
  if (viewConfig.conditionV2.length === 1 || viewConfig.conditionV2.length === 2) {
    const {
      condition,
      conditionV2,
      ...rest
    } = viewConfig;
    return rest;
  }
  return viewConfig;
};

//处理分组信息==分组信息
function handleGroupCondition(filterReq, viewInfo) {
  if (viewInfo) {
    if (viewInfo.type === "status") {
      filterReq.groupBy.push(`si`);
    } else if (viewInfo.type === "temp") {
      const param = viewInfo.group.split("_");
      if (param.length) {
        filterReq.groupBy.push(`p${(param && param[3] == 1 ? "g" : "") + viewInfo.index}`);
      }
      // else {
      //   /**
      //    * TODO: @xuxi
      //    * 根据属性分组未支持地址属性的province city district street
      //    * 还不支持  此时数据应该为空
      //    */
      // }
    } else if (viewInfo.type === "sysCreator") {
      filterReq.groupBy.push(`createUser`);
    } else if (viewInfo.type === "sysTag") {
      filterReq.groupBy.push(`t`);
    } else if (viewInfo.type === "templateStatusPropBase_0") {
      filterReq.groupBy.push(`s0`);
    } else if (viewInfo.type === "templateStatusPropBase_0_0") {
      filterReq.groupBy.push(`s0`);
    } else if (viewInfo.type === "templateStatusPropBase_0_1") {
      filterReq.groupBy.push(`sg0`);
    } else if (viewInfo.type === "templateStatusPropBase_1") {
      filterReq.groupBy.push(`s1`);
    } else if (viewInfo.type === "templateStatusPropBase_1_0") {
      filterReq.groupBy.push(`s1`);
    } else if (viewInfo.type === "templateStatusPropBase_1_1") {
      filterReq.groupBy.push(`sg1`);
    } else if (viewInfo.type === "templateStatusOwnerAndParticipant" || viewInfo.type === "templateStatusOwnerAndParticipant_0") {
      filterReq.groupBy.push(`so`);
    } else if (viewInfo.type === "templateStatusOwnerAndParticipant_1") {
      filterReq.groupBy.push(`sog`);
    }
  } else {
    delete filterReq.groupBy;
  }
  return filterReq;
}

//处理视图筛选条件
function handleConditionParam(filterReq, viewConfig, baseUserId, storeUserId, hasHistoryStatus, propList) {
  //新筛选条件
  if (viewConfig && viewConfig.conditionV2 && viewConfig.conditionV2.length && viewConfig.conditionV2.length >= 2) {
    viewConfig.conditionV2 = viewConfig.conditionV2.map((x, i) => {
      if (i.key === "templateId" || i.key === "ancestor" || x.key === "status") {
        x.op = "intersect";
      } else if (i > 1 && x.op === "timeBein" && (x.input.length > 2 || x.input[0] === x.input[1])) {
        if (x.input.length > 2) {
          //近几日
          const endTime = dayjs(dayjs().format("YYYY/MM/DD") + " 23:59:59").valueOf();
          const startTime = endTime - (Number(x.input[2]) + 1) * 24 * 60 * 60 * 1000 + 1000;
          x.input = [startTime, endTime];
        } else {
          //开始结束时间
          const startTime = dayjs(dayjs(x.input[0]).format("YYYY/MM/DD") + " 00:00:00").valueOf();
          const endTime = dayjs(dayjs(x.input[0]).format("YYYY/MM/DD") + " 23:59:59").valueOf();
          x.input = [startTime, endTime];
        }
      } else if (x?.extends?.type === "text") {
        x.op = "textInclude";
      } else if (x?.extends?.type === "user" && x.input.length === 1 && x.input[0] === null) {
        x.input = [baseUserId];
      } else if (x.key === "sysCreator" || x.key === "statusProp" && (x.index === 0 || x.index === 1) || x.key === "templateStatusOwnerAndParticipant") {
        if (Array.isArray(x.input)) {
          x.input = x.input.map(y => y === null ? baseUserId : y);
        } else {
          x.input = x.input === null ? baseUserId : x.input;
        }
      }
      return x;
    });
    delete filterReq.parentId;
    delete filterReq.temp_id;
    filterReq.conditionV2 = viewConfig.conditionV2;
  } else {
    //原始筛选条件
    if (viewConfig && viewConfig.condition && viewConfig.condition.length && viewConfig.condition.length > 1) {
      viewConfig.condition.slice(1).forEach((
      /**
       * @type {
       *  value: any;
       *  type: string;
       *  key: string;
       * }
       */
      x) => {
        if (typeof x.value === "undefined") return;
        if (/^templateProp_/g.test(x.key)) {
          const propParam = x.key.split("_");
          let conditionValue = x.value;
          // NOTE: 可能是个数组
          if (typeof x.value === "string") {
            conditionValue = [conditionValue];
          }
          if (!Array.isArray(conditionValue)) return;
          const propVals = conditionValue?.map(y => {
            let value = y;
            if (x.type === "user" && isNil(y)) {
              value = storeUserId;
            }
            return `p${propParam[2]}-${value}`;
          });
          if (x.value && /^\d{13}$/.test(x.value[0]?.toString())) {
            const pidx = Number(x.key?.split("_")[2]) || -1;
            let propConfig,
              less_val = x.value[1],
              great_val = x.value[0];
            if (Number(pidx) >= 0) {
              propConfig = propList.find(x => Number(x.newIndex) == pidx);
            }
            if (propConfig?.dateFormat) {
              const [gv, lv] = getDateFormatTimeStamp(propConfig.dateFormat, x);
              great_val = gv;
              less_val = lv;
            }
            const formulaVal = AND(LESS_EQUAL(PROP(propParam[2]), less_val), GREAT_EQUAL(PROP(propParam[2]), great_val)).formula;
            filterReq.formula = formulaVal;
          } else {
            filterReq.tempProps.push(propVals);
          }
        } else if (/^_sys_creator$/g.test(x.key)) {
          let val = x.value;
          if (val && val.length === 1 && val[0] === null) {
            val = [baseUserId];
          }
          filterReq = {
            ...filterReq,
            createUser: val
          };
        } else if (/^_sys_createTime$/g.test(x.key)) {
          let val = x.value;
          if (x.value && x.value.length && x.value.length === 2) {
            const ds = dayjs(dayjs(x.value[0]).format("YYYY/MM/DD") + " 00:00:00").valueOf();
            const de = dayjs(dayjs(x.value[1]).format("YYYY/MM/DD") + " 23:59:59").valueOf();
            val = [ds, de];
          }
          filterReq.filterTime = Object.assign(filterReq.filterTime, {
            createTime: val
          });
        } else if (/^_sys_tag$/g.test(x.key)) {
          const tags = x.value.map(y => `t-${y}`);
          filterReq.tempProps.push(tags);
        } else if (/^templateStatus$/g.test(x.key) && !hasHistoryStatus) {
          const status = x.value.map(y => `si-${y.split("_")[1]}`);
          filterReq.tempProps.push(status);
        } else if (/^templateStatusPropBase_0$/g.test(x.key) && !hasHistoryStatus) {
          let principal;
          if (x.value && x.value[0]) {
            principal = x.value.map(y => `s0-${y}`);
          } else {
            principal = x.value?.map(y => `s0-${baseUserId}`);
          }
          filterReq.tempProps.push(principal);
        } else if (/^templateStatusPropBase_1$/g.test(x.key) && !hasHistoryStatus) {
          const participant = x.value.map(y => `s1-${y}`);
          filterReq.tempProps.push(participant);
        } else if (/^templateStatusPropBase_2$/g.test(x.key)) {
          filterReq.filterTime = Object.assign(filterReq.filterTime, {
            startTime: x.value
          });
        } else if (/^templateStatusPropBase_3$/g.test(x.key)) {
          filterReq.filterTime = Object.assign(filterReq.filterTime, {
            endTime: x.value
          });
        } else if (/^templateStatusOwnerAndParticipant$/g.test(x.key) && !hasHistoryStatus) {
          const p = [`s0-${x.value[0]}`, `s1-${x.value[0]}`];
          filterReq.tempProps.push(p);
        } else if (/^historyStatus$/g.test(x.key)) {
          let currentStatus = [],
            historyStatus = [],
            owner = [],
            user = [],
            both = [];
          viewConfig.condition.map(x => {
            if (/^templateStatusPropBase_0$/g.test(x.key)) {
              owner = x.value[0] ? x.value[0] : baseUserId;
              owner = [owner];
            } else if (/^templateStatusPropBase_1$/g.test(x.key)) {
              user = x.value;
            } else if (/^templateStatusOwnerAndParticipant$/g.test(x.key)) {
              both = x.value[0];
            } else if (/^historyStatus$/g.test(x.key)) {
              historyStatus = x.value.reduce((a, b) => {
                a.push(b.split("_")[1]);
                return a;
              }, []);
            } else if (/^templateStatus$/g.test(x.key)) {
              currentStatus = x.value.map(y => `${y.split("_")[1]}`);
            }
          });
          filterReq.historyCurrentOwner = {
            historyStatus,
            currentStatus,
            owner,
            user,
            both
          };
        }
      });
    }
  }
  return filterReq;
}

//节点的过滤条件
function handleFilterNodeOption(filterReq, filterNodeOption) {
  if (filterNodeOption && filterNodeOption.length) {
    filterNodeOption.forEach(x => {
      if (/^\d{13}_/g.test(x)) {
        const time_c = Number(x.match(/\d{13}/)[0]);
        const startTime = dayjs(time_c).format("YYYY-MM-DD") + " 00:00:00";
        const endTime = dayjs(time_c).format("YYYY-MM-DD") + " 23:59:59";
        const timeType = /^\d{13}_c$/g.test(x) ? "createTime" : /^\d{13}_s$/g.test(x) ? "startTime" : "endTime";
        filterReq.filterTime = Object.assign(filterReq.filterTime, {
          [timeType]: [Number(dayjs(startTime).valueOf()), Number(dayjs(endTime).valueOf())]
        });
      } else if (/^[0-9A-Z]{32}_c$/g.test(x)) {
        filterReq = {
          ...filterReq,
          createUser: x.match(/[0-9A-Z]{32}/)[0]
        };
      } else if (/^[0-9A-Z]{32}_s0$/g.test(x)) {
        filterReq.tempProps.push(`s0-${x.match(/[0-9A-Z]{32}/)[0]}`);
      } else if (/^[0-9A-Z]{32}_s1$/g.test(x)) {
        filterReq.tempProps.push(`s1-${x.match(/[0-9A-Z]{32}/)[0]}`);
      } else {
        filterReq.tempProps.push(x);
      }
    });
  }
  return filterReq;
}